import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import BinFileLine from '../entities/binfileline';
import Util from '@/lib/util';
import appconst from './../../lib/appconst';

interface BinFileState extends ListState<BinFileLine> {
    itemsImported: Array<BinFileLine>,
    countItems : number,
    countImportedItems: number
}
class BinFileModule extends ListModule<BinFileState, any, BinFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BinFileLine>(),
        loading: false,
        itemsImported: new Array<BinFileLine>(),
        countItems:0,
        countImportedItems:0
    }
    actions = {
        async getAll(context: ActionContext<BinFileState, any>, payload: any) {
            context.state.totalCount = context.state.itemsImported.length;
        },
        async uploadImportBinFile(context: ActionContext<BinFileState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/BinFile/ImportBins', data);
            return reponse.data.result
        },
        async export(context:ActionContext<BinFileState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportBins/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: BinFileState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BinFileState, pagesize: number) {
            state.pageSize = pagesize;
        },
        processNotifier(state: BinFileState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let binLine = payload.data.data as BinFileLine;
                    state.itemsImported.unshift(binLine);
                }
                if (payload.data.countItems != undefined && payload.data.countItems != null && payload.data.countItems > 0) {
                    state.countItems = payload.data.countItems as number;
                }
                if (payload.data.countImportedItems != undefined && payload.data.countImportedItems != null && payload.data.countImportedItems> 0) {
                    state.countImportedItems = payload.data.countImportedItems as number;
                }
            }

        },
        resetList(state: BinFileState) {
            state.itemsImported = new Array<BinFileLine>();
        } ,
        pageChangeItemsImported(state: BinFileState) {
            state.list = Util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const binFileModule = new BinFileModule();
export default binFileModule;